import { React, useEffect } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Button, Input } from "../components/Form";
import { BiLogInCircle } from "react-icons/bi";
import {
  loginUser,
  selectAuthStatus,
  selectAuthError,
} from "../redux/features/authSlice";
import toast from "react-hot-toast";
import Loading from "./Loading";
import { logger } from "../services/logger";

function Login() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const status = useSelector(selectAuthStatus);
  const error = useSelector(selectAuthError);

  useEffect(() => {
    logger.info("Página de login cargada", {
      component: "Login",
      additionalData: {
        path: window.location.pathname,
      },
    });
  }, []);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: {
      username: "",
      password: "",
    },
  });

  const onSubmit = async (credentials) => {
    console.log("Login credentials:", credentials);

    try {
      const result = await dispatch(loginUser(credentials)).unwrap();

      toast.success("Inicio de sesión exitoso");
      navigate("/"); // Redirige al dashboard después del login
    } catch (error) {
      console.error("Error detail:", error); // Para debugging
      // Maneja diferentes formatos de error
      const errorMessage =
        error.message ||
        error.response?.data?.message ||
        "Error al iniciar sesión";
      toast.error(errorMessage);
    }
  };

  if (status === "loading") {
    return <Loading />;
  }

  // Función para extraer el mensaje de error en diferentes formatos
  const getErrorMessage = (errorObj) => {
    if (typeof errorObj === "string") return errorObj;
    if (errorObj?.message) return errorObj.message;
    if (errorObj?.response?.data?.message)
      return errorObj.response.data.message;
    return "Error desconocido";
  };

  return (
    <div className="w-full h-screen flex-colo bg-dry">
      <form
        onSubmit={handleSubmit(onSubmit)}
        className="w-full md:w-2/5 p-8 rounded-2xl mx-auto bg-white flex-colo shadow-lg"
      >
        <img
          src="/logo.png"
          alt="logo"
          className="w-30 h-20 object-contain mb-6"
        />
        <h2 className="text-2xl font-bold text-center mb-6">
          Inicio de Sesión
        </h2>

        <div className="flex flex-col gap-4 w-full mb-6">
          <Input
            label="Usuario"
            type="text"
            color={true}
            placeholder={"Ingrese su usuario"}
            register={register("username", {
              required: "El usuario es requerido",
              minLength: {
                value: 3,
                message: "El usuario debe tener al menos 3 caracteres",
              },
            })}
            error={errors.username}
          />
          <Input
            label="Contraseña"
            type="password"
            color={true}
            placeholder={"Ingrese su contraseña"}
            register={register("password", {
              required: "La contraseña es requerida",
              minLength: {
                value: 6,
                message: "La contraseña debe tener al menos 6 caracteres",
              },
            })}
            error={errors.password}
          />
        </div>

        {error && (
          <div className="mb-4 p-2 text-sm text-center text-red-600 bg-red-100 rounded">
            {getErrorMessage(error)}
          </div>
        )}

        <Button
          type="submit"
          label={
            status === "loading" ? "Iniciando sesión..." : "Iniciar Sesión"
          }
          Icon={BiLogInCircle}
          disabled={status === "loading"}
          className="w-full"
        />
      </form>
    </div>
  );
}

export default Login;
